import { useEffect } from 'react';

import { Link, useParams } from 'react-router';

import { getAttribute, getAttributeValue } from '@boc/framework/products/attributes';

import { urls } from '~/urls';

import { useProductDetails } from '~/framework/routes/products/providers';

import BaseAddToCart from '~/local/checkout/components/AddToCart';
import { Price as PPrice } from '~/local/components/price';

import { DiscountBadge } from './product-tag';
import Quantity from './quantity';

export { DiscountBadge };

export const Title = () => {
  const { product } = useProductDetails();

  return (
    <h1 className="font-heading-condensed text-xl leading-7 font-medium tracking-tight">
      {product.name}
    </h1>
  );
};

const JigsawPuzzleSubTitle = () => {
  const { product, variant } = useProductDetails();

  const pieces = getAttributeValue(
    [...product.attributes, ...variant.attributes],
    'puzzle-pieces',
    (pieces) => `${pieces} Piece`
  );

  const attrPieceCount = getAttribute(product.attributes, 'puzzle-piece-count');

  const attrArtist = getAttribute(product.attributes, 'puzzle-artist');

  const params = useParams();

  return (
    <h2 className="font-heading-condensed text-medium leading-3 tracking-tight">
      A{' '}
      <Link
        to={
          attrPieceCount?.values.length && attrPieceCount?.values.length > 0
            ? urls.products.attributeWithCategory(params, {
                categorySlug: product.category?.slug || '',
                attributeSlug: attrPieceCount.attribute.slug || '',
                valueSlug: attrPieceCount.values[0].slug || '',
              })
            : urls.products.categories(params, { slug: 'jigsaw-puzzles' })
        }
      >
        {pieces ? `${pieces} Jigsaw Puzzle` : 'Jigsaw Puzzle'}
      </Link>
      {attrArtist?.values.length && attrArtist?.values.length ? (
        <>
          {' '}
          <Link
            to={urls.products.attributeWithCategory(params, {
              categorySlug: product.category?.slug || '',
              attributeSlug: attrArtist.attribute.slug || '',
              valueSlug: attrArtist.values[0].slug || '',
            })}
          >
            by {attrArtist.values[0].name}
          </Link>
        </>
      ) : null}
    </h2>
  );
};

export const SubTitle = () => {
  const {
    product: {
      productType: { slug },
    },
  } = useProductDetails();

  switch (slug) {
    case 'jigsaw-puzzle':
      return <JigsawPuzzleSubTitle />;
    default:
      return <></>;
  }
};

export const Price = () => {
  const { variant } = useProductDetails();

  const pricing = variant.pricing;

  return (
    <div className="flex flex-row-reverse">
      <div className="font-heading-condensed space-x-3 text-lg leading-6 font-medium tracking-tight">
        {pricing?.onSale ? (
          <PPrice price={variant.pricing?.priceUndiscounted?.gross} className="line-through" />
        ) : (
          <></>
        )}
        <PPrice price={pricing?.price?.gross} />
      </div>
    </div>
  );
};

export const AddToCartOrWishlist = () => {
  const { variant, quantity, isAvailable, product } = useProductDetails();

  return (
    <div className="flex justify-between space-x-10">
      <Quantity>
        <Quantity.Minus />
        <Quantity.Value />
        <Quantity.Plus />
      </Quantity>
      <div className="flex-1">
        <BaseAddToCart
          disabled={!isAvailable}
          variant={variant}
          product={product}
          quantity={quantity}
        >
          Add to cart
        </BaseAddToCart>
      </div>
    </div>
  );
};
